<template>
	<div class="container page" style="background: #1f1c1f;">
		<van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar">
			<template #left>
				<img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;" />
			</template>
		</van-nav-bar>
		<div class="main-box">
			<div class="label">{{$t("setting.fill_bank_tip")}}</div>
			<van-cell-group>
				
				<!-- 币种选择 -->
				<van-field v-model="currency" :label="$t('setting.select_currency')"
					:placeholder="$t('setting.select_currency_tip')" readonly @click="showCurrencyPicker = true" />

				<!-- 收款地址 -->
				<van-field v-model="address" :label="$t('setting.receiving_address')"
					:placeholder="$t('setting.receiving_address_tip')" />

				<!-- 名字 -->
				<van-field v-model="username" :label="$t('setting.name')" :placeholder="$t('setting.name_tip')" />

			</van-cell-group>
			<p>{{$t("setting.bank_warn")}}</p>
		</div>
		<div class="sub-btn" @click="bindCard()">
			{{$t("setting.bank_ok")}}
		</div>

		<!-- 币种选择弹窗 -->
		<van-popup v-model="showCurrencyPicker" round position="bottom" :style="{ height: '35%' }">
			<van-picker show-toolbar :columns="currencies" cancel-button-text="Cancel" confirm-button-text="Confirm"
				@confirm="onCurrencyConfirm" @cancel="onCurrencyCancel" />
		</van-popup>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				currencies: [
					{
						text: 'BTC',
						value: 'BTC'
					},
					{
						text: 'ETH',
						value: 'ETH'
					},
					{
						text: 'USDC',
						value: 'USDC'
					},
					{
						text: 'USDT',
						value: 'USDT'
					}
				],
				showCurrencyPicker: false,
				userInfo: {},
				currency: "", // 币种
				address: "", // 收款地址
				username: "" // 名字
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			bindCard() {
				// 验证是否已绑定
				// if (this.userInfo.bankid) {
				// 	this.$toast(this.$t("setting.band_account_tip"));
				// 	return false;
				// }

				// 验证币种
				if (this.currency === "" || this.currency === null || this.currency === undefined) {
					this.$toast(this.$t("setting.select_currency_tip"));
					return false;
				}

				// 验证收款地址
				if (this.address === "") {
					this.$toast(this.$t("setting.receiving_address_tip"));
					return false;
				}

				// 验证名字
				if (this.username === "") {
					this.$toast(this.$t("setting.name_tip"));
					return false;
				}

				this.$http({
					method: 'post',
					data: {
						bankid: this.bankid,
						currency: this.currency,
						address: this.address,
						username: this.username
					},
					url: 'user_set_bank'
				}).then(res => {
					if (res.code === 200) {
						this.$router.push({
							path: '/Mine'
						})
						this.$toast(res.msg);
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			getUserBankInfo() {
				this.$http({
					method: 'get',
					url: 'user_get_bank'
				}).then(res => {
					if (res.code === 200) {
						if (res.data.is_bank) {
							this.userInfo.bankid = true;
							this.currency = res.data.info.type || '';
							this.address = res.data.info.bankid || '';
							this.username = res.data.info.username || '';
						} else {
							this.userInfo.bankid = false;
						}
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			onCurrencyConfirm(value) {
				this.currency = value.text;
				this.showCurrencyPicker = false;
			},
			onCurrencyCancel() {
				this.showCurrencyPicker = false;
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserInfo();
				this.getUserBankInfo();
			}
		}
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.sub-btn {
		background: linear-gradient(#fde3ca, #e7b486);
		display: inline-block;
		border: none;
		cursor: pointer;
		color: #68302c;
		font-size: 32px;
		-moz-border-radius: 5px;
		-webkit-border-radius: 5px;
		border-radius: 2rem;
		margin: 60px 40px;
		font-weight: bold;
		text-align: center;
		padding: 20px 0;
		width: calc(100% - 80px);
	}

	/deep/ .van-field__label {
		color: #ccc;
	}

	.van-cell-group {
		background-color: transparent;
		padding: 30px 0;

		&:after {
			display: none;
		}
	}

	.van-cell {
		background: linear-gradient(120deg, #212121, #313131);
		margin: 0 30px;
		box-sizing: border-box;
		width: initial;
		border: 1px solid #766350;
		border-radius: 10px;
		font-size: 28px;
		padding: 20px 26px;
		margin-bottom: 20px;

		/deep/ .van-field__control {
			color: #f3c7a2;
		}

		&:after {
			display: none;
		}
	}

	.main-box .label {
		padding: 20px 0 20px 26px;
		font-size: 35px;
		color: #f3c7a2;
	}

	::v-deep .van-picker__toolbar {
		height: 50px;
	}

	::v-deep .van-picker__cancel,
	.van-picker__confirm {
		padding: 0 20px;
		font-size: 20px;
	}

	::v-deep .van-picker-column {
		font-size: 40px;
	}

	.main-box p {
		padding: 0 20px;
		font-size: 30px;
		color: #f3c7a2;
	}
</style>